// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"611":"31d6cfe0","1457":"ecc5eaea","3068":"d308df67","3244":"ef90f595"}[chunkId] + ".chunk.css";
};